import { useQueryClient } from '@tanstack/react-query';
import { useSocketEvent } from '@/hooks/socket/useSocketEvent';
import { useAppSelector } from '@/redux/hooks';
import { bannerQueryOptions } from './banners.queries';

export interface AssignedBanner {
  bannerId: string;
  name: string;
  group: string | null;
}

export interface BannerAssignedContext {
  userId: string;
  banners: AssignedBanner[];
}

export function useBannersSocket() {
  const queryClient = useQueryClient();
  const userSession = useAppSelector(state => state.user.userSession);

  useSocketEvent<BannerAssignedContext>(
    'banner.assigned',
    () => {
      const usersBannersQuery = bannerQueryOptions.usersBanners({ staleTime: 0 });

      void queryClient.invalidateQueries({
        queryKey: usersBannersQuery.queryKey,
        refetchType: 'none',
      });
      void queryClient.fetchQuery(usersBannersQuery);
    },
    Boolean(userSession),
  );
}
